import { axiosDefaultConfig } from 'constants/axios'
import {
  CampaignStatusEnum,
  CampaignsApi,
  CampaignsProgramsCreateParticipantsInner,
  CampaignsProgramsCreateRequest,
  CampaignsProgramsCreateTargetsInner,
  CampaignsProgramsGetDetailParticipantsInner,
  CampaignsProgramsGetDetailRequest,
  Configuration,
  Mill,
  MillsApi,
  SupplierContractsApi,
} from 'generated/api'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const axiosConfig = new Configuration(axiosDefaultConfig)
const millsApi = new MillsApi(axiosConfig)
const campaignsApi = new CampaignsApi(axiosConfig)
const supplierContracts = new SupplierContractsApi(axiosConfig)

export interface ExtendedCampaignsProgram extends CampaignsProgramsCreateRequest {
  id?: string | undefined
  participantsCandidate?: CampaignsProgramsCreateParticipantsInner[]
  partnerName: string
  participantsExtend: ExtendedUser[]
  createdAt?: number
  status?: CampaignStatusEnum
}

export interface ExtendedUser extends CampaignsProgramsCreateParticipantsInner {
  id: string
  campaignGoldId?: string
  name?: string
  createdAt?: number
}

export const useCampaign = () => {
  const navigate = useNavigate()
  const [status, setStatus] = useState('')
  const [mills, setMills] = useState<Mill[]>([])
  const [openModal, setOpenModal] = useState(false)
  const [participants, setParticipants] = useState<ExtendedUser[]>([])
  const [detailCampaign, setDetailCampaign] = useState<ExtendedCampaignsProgram>({
    partnerId: '',
    version: 1,
    name: '',
    startTime: 0,
    endTime: 0,
    participants: [] as CampaignsProgramsCreateParticipantsInner[],
    id: '',
    participantsCandidate: [] as CampaignsProgramsCreateParticipantsInner[],
    partnerName: '',
    participantsExtend: [] as ExtendedUser[],
  })

  useEffect(() => {
    getMills()
  }, [])

  // const addCampaignDuration = async () => {
  //   try {
  //     setStatus('LOADING')
  //     await campaignsApi.campaignsProgramsGoldTargetAdd(
  //       [] as CampaignsProgramsGoldTargetAddRequestInner[],
  //     )
  //     setStatus('')
  //   } catch {
  //     setStatus('FAILED')
  //   }
  // }

  // const addCampaignParticipant = async () => {
  //   try {
  //     setStatus('LOADING')
  //     await campaignsApi.campaignsProgramsGoldCreate({} as CampaignsProgramsGoldCreateRequest)
  //     setStatus('')
  //   } catch {
  //     setStatus('FAILED')
  //   }
  // }

  const createCampaign = async (detail: ExtendedCampaignsProgram) => {
    try {
      setStatus('LOADING')
      const payload = {
        partnerId: detail.partnerId,
        version: detail.version,
        name: detail.name,
        startTime: detail.startTime,
        endTime: detail.endTime,
        participants: detail.participantsExtend,
      } as CampaignsProgramsCreateRequest
      await campaignsApi.campaignsProgramsCreate(payload)
      setStatus('')
      navigate('/campaign', { state: { createToast: 'success' } })
    } catch {
      setStatus('FAILED')
      navigate('/campaign', { state: { createToast: 'failed' } })
    }
  }

  const getMills = async () => {
    try {
      setStatus('LOADING')
      const { data } = await millsApi.getMills('ADMIN_WEB', '', true)
      setMills(data.items)
      setStatus('')
    } catch {
      setStatus('FAILED')
    }
  }

  const getUsersParticipant = async (partnerId: string) => {
    try {
      setStatus('LOADING')
      const { data } = await supplierContracts.supplierContractsUsersGet(partnerId)
      const newFormatted = data.items.map(item => ({
        userId: item.id,
        id: item.id,
        name: item.name,
        targets: [
          { startTime: 0, endTime: 0, targetFfbWeightTonne: 0, type: 'DAILY' },
          { startTime: 0, endTime: 0, targetFfbWeightTonne: 0, type: 'MONTHLY' },
          { startTime: 0, endTime: 0, targetFfbWeightTonne: 0, type: 'QUARTERLY' },
        ] as CampaignsProgramsCreateTargetsInner[],
      }))
      setParticipants(newFormatted)
      setStatus('')
    } catch {
      setStatus('FAILED')
    }
  }

  const getExtendedParticipants = (
    campaignParticipants: CampaignsProgramsGetDetailParticipantsInner[],
  ) => {
    return campaignParticipants.map(data => {
      return {
        ...data,
        name: data.userName,
        id: data.userId,
      }
    })
  }

  const getCampaignDetail = async () =>
    // id: string
    {
      try {
        setStatus('LOADING')
        // const { data } = await campaignsApi.campaignsProgramsGetDetail(id)
        const data = {
          id: '2ced2567-5980-4e3b-b68c-d3ffdb99d9d9',
          name: 'Campaign Emas ASMJ',
          partnerId: 'ea9e0f71-43ba-4a1a-b0a3-a15ce470f626',
          partnerName: 'PT INTI INDOSAWIT',
          version: 2,
          startTime: 1714525200000,
          endTime: 1717117200000,
          createdAt: 1714471505000,
          totalParticipants: 15,
          participants: [
            {
              campaignGoldId: 'ab08205a-caf8-4b17-8008-c137f347e320',
              userId: '277f7b1c-35d8-43bb-8af5-02e21e7e32d3',
              userName: 'Saka Ardianto',
              createdAt: 1714471505000,
              targets: [
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 500,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 1500,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 600,
                  startTime: 1717223456000,
                  endTime: 1719729056000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 1700,
                  startTime: 1717223456000,
                  endTime: 1719729056000,
                },
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 700,
                  startTime: 1719815456000,
                  endTime: 1722321056000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 2000,
                  startTime: 1719815456000,
                  endTime: 1722321056000,
                },
                {
                  type: 'QUARTERLY',
                  targetFfbWeightTonne: 5000,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
              ],
            },
            {
              campaignGoldId: 'ab08205a-caf8-4b17-8008-c137f347e320',
              userId: '277f7b1c-35d8-43bb-8af5-02e21e7e3dd3',
              userName: 'Ujang',
              createdAt: 1714471505000,
              targets: [
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 700,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 2000,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 800,
                  startTime: 1717223456000,
                  endTime: 1719729056000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 2200,
                  startTime: 1717223456000,
                  endTime: 1719729056000,
                },
                {
                  type: 'DAILY',
                  targetFfbWeightTonne: 1000,
                  startTime: 1719815456000,
                  endTime: 1722321056000,
                },
                {
                  type: 'MONTHLY',
                  targetFfbWeightTonne: 3000,
                  startTime: 1719815456000,
                  endTime: 1722321056000,
                },
                {
                  type: 'QUARTERLY',
                  targetFfbWeightTonne: 8000,
                  startTime: 1714525200000,
                  endTime: 1717117200000,
                },
              ],
            },
          ],
          participantCandidates: [
            {
              userId: '277f7b1c-35d8-43bb-8af5-02e21e7e32d3',
              userName: 'Saka Ardianto',
            },
          ],
        } as CampaignsProgramsGetDetailRequest
        const tempParticipants = getExtendedParticipants(data.participants)
        setDetailCampaign({
          ...data,
          participantsExtend: tempParticipants,
        })
        setStatus('')
      } catch {
        setStatus('FAILED')
      }
    }

  const target = (
    targetsForMonth: CampaignsProgramsCreateTargetsInner[],
    record: CampaignsProgramsCreateParticipantsInner,
    type: string,
  ) => {
    return targetsForMonth.find(
      (t: CampaignsProgramsCreateTargetsInner & { userId?: string }) =>
        t.type === type && t.userId === record.userId,
    )
  }

  const handleOpenModal = () => {
    setOpenModal(true)
  }

  return {
    status,
    mills,
    detailCampaign,
    setDetailCampaign,
    setMills,
    getMills,
    getUsersParticipant,
    getCampaignDetail,
    createCampaign,
    participants,
    target,
    openModal,
    setOpenModal,
    handleOpenModal,
  }
}
